module.exports = __webpack_public_path__ + "static/class-notes-banner-66d1a3e45cf9592574669a49cb31d2d4.jpg";